import { useCallback, useEffect, useState } from 'react'

const ZOOM_MIN = 1
const ZOOM_MAX = 5
const ZOOM_STEP = 0.5

export const useImageZoom = (isOpen: boolean) => {
  const [zoomLevel, setZoomLevel] = useState(1)

  const zoomIn = useCallback(() => {
    setZoomLevel((prev) => Math.min(prev + ZOOM_STEP, ZOOM_MAX))
  }, [])

  const zoomOut = useCallback(() => {
    setZoomLevel((prev) => Math.max(prev - ZOOM_STEP, ZOOM_MIN))
  }, [])

  const resetZoom = useCallback(() => {
    setZoomLevel(1)
  }, [])

  useEffect(() => {
    if (!isOpen) {
      setZoomLevel(1)
    }
  }, [isOpen])

  return {
    zoomLevel,
    zoomIn,
    zoomOut,
    resetZoom,
    canZoomIn: zoomLevel < ZOOM_MAX,
    canZoomOut: zoomLevel > ZOOM_MIN,
    isZoomed: zoomLevel > 1,
  }
}
